<template>
  <!-- Switchable <Drop> -->
  <drop v-if="active" v-bind="$attrs" v-on="$listeners">
    <slot />
  </drop>
  <div v-else v-bind="$attrs" >
    <slot />
  </div>
</template>

<script>
import { Drop } from 'vue-drag-drop'
export default {
  name: 'SwDrop',
  components: { Drop },
  inheritAttrs: false,
  props: {
    active: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/SwDrop.vue